/* eslint-disable no-nested-ternary */
import React, { createRef } from 'react'
import PropTypes from 'prop-types'
import { Button as MuiButton, Tooltip } from '@mui/material'
import ColorLens from '@mui/icons-material/ColorLens'
import CloseIcon from '@mui/icons-material/Close'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'

import { variantTypes, colorTypes } from '../../../constants'
import { Icon } from '../../icons'
import './style.scss'

/**
 * Mode of Button display, each of this mode have its own CSS.
 */
export const buttonModes = {
  HEADER: 'header',
  PRIMARY_ACTION: 'primary_action',
  SECONDARY_ACTION: 'secondary_action',
  TABS_ACTION: 'tabs_action'
}

/**
 * Types of HTML buttons
 */
export const buttonTypes = {
  BUTTON: 'button',
  SUBMIT: 'submit',
  RESET: 'reset'
}

/**
 *
 * @param {object} param Object Ex: <Button
                                      mode={buttonModes.PRIMARY_ACTION}
                                      type={buttonTypes.SUBMIT}
                                      text={'click me!'}
                                      tooltip={'will do this action on click'}
                                      icon={<CloseIcon/> || <Icon name={iconNames.CLOCK} size={20}/>}
                                      onClick={e => { console.log(e) }}
                                      className="my-css-class-name"
                                    />
 *
 * @returns {MuiButton}
 */
export const Button = ({ mode, type, text, tooltip, icon, onClick, className, disabled }) => {
  const ref = createRef()

  let color, rootClassName, variant
  switch (mode) {
    default: {
      icon = icon ? typeof icon === 'string' ? <Icon name={icon} size={20} /> : icon : <ColorLens />
      color = colorTypes.PRIMARY
      variant = variantTypes.OUTLINED
      rootClassName = 'buttons_buttonsHeader'
      break
    }

    case buttonModes.HEADER: {
      icon = icon ? icon : <ColorLens />
      color = colorTypes.PRIMARY
      variant = variantTypes.OUTLINED
      rootClassName = 'buttons_buttonsHeader'
      break
    }

    case buttonModes.SECONDARY_ACTION: {
      icon = icon ? icon : <CloseIcon />
      color = colorTypes.SECONDARY
      variant = variantTypes.CONTAINED
      rootClassName = 'buttons_buttonsSecondaryAction'
      break
    }

    case buttonModes.PRIMARY_ACTION: {
      icon = icon ? icon : <NavigateNextIcon />
      color = colorTypes.PRIMARY
      variant = variantTypes.CONTAINED
      rootClassName = 'buttons_buttonsPrimaryAction'
      break
    }

    case buttonModes.TABS_ACTION: {
      icon = icon ? icon : <ColorLens />
      color = colorTypes.PRIMARY
      variant = variantTypes.OUTLINED
      rootClassName = 'buttons_buttonsTabs'
      break
    }
  }

  return tooltip ? (
    <Tooltip ref={ref} title={tooltip}>
      <MuiButton
        variant={variant}
        color={color}
        className={`${rootClassName} ${className}`}
        startIcon={icon}
        onClick={onClick}
        type={type}
        disabled={disabled}
      >
        {text}
      </MuiButton>
    </Tooltip>
  ) : (
    <MuiButton
      variant={variant}
      color={color}
      className={`${rootClassName} ${className}`}
      startIcon={icon}
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      {text}
    </MuiButton>
  )
}

Button.displayName = 'Button'

Button.propTypes = {
  type: PropTypes.oneOf([buttonTypes.BUTTON, buttonTypes.SUBMIT, buttonTypes.RESET]),
  mode: PropTypes.oneOf([
    buttonModes.HEADER,
    buttonModes.PRIMARY_ACTION,
    buttonModes.SECONDARY_ACTION,
    buttonModes.TABS_ACTION
  ]).isRequired,
  text: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.any,
  tooltip: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool
}

Button.defaultProps = {
  type: buttonTypes.BUTTON,
  mode: buttonModes.HEADER,
  text: '',
  onClick: () => {},
  color: 'primary',
  icon: null,
  tooltip: null,
  className: '',
  disabled: false
}
